import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function Icon({icon}) {
  return (
    <div
    className=" hover:text-blue-500 text-gray-700  h-6 w-6 flex justify-center items-center cursor-pointer"
    >
        <FontAwesomeIcon icon={icon} />
    </div>
  )
}
